import { Box } from '@palmetto/palmetto-components';

import EventBy from './EventBy';

const SabalOrganizationCreated = ({ event }: { event: any }) => {
  return (
    <Box display="block">
      <EventBy event={event} /> created this organization
    </Box>
  );
};

export default SabalOrganizationCreated;
